import React from 'react';
import Button from 'components/ui/button';

interface Props {
  id: string;
  createButtonText: string;
  backButtonText: string;
  backUrl: string;
  canCreate: boolean;
  isFileLoading: boolean;
  isFilePreview: boolean;
  isBatchPreview: boolean;
  onBackCallback?: () => void;
  onCreate: () => void;
}

export const MassPaymentFooter: React.FC<Props> = (props) => {
  return (
    <>
      <Button
        status='outline'
        text={props.backButtonText}
        link={props.backUrl}
        onClick={props.onBackCallback}
      />

      <Button
        type='submit'
        status='primary'
        text={props.createButtonText}
        id={`mass-${props.id}-button-submit`}
        disabled={
          (!props.canCreate && !props.isFilePreview) ||
          (props.isBatchPreview && !props.canCreate)
        }
        loading={props.isFileLoading}
        onClick={props.onCreate}
      />
    </>
  );
};
